export default __webpack_public_path__ + "static/media/Ntorq125Racing_Posterior.f9fb6968.webp";